// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-waterfall';

export const Component = () => (
  <path d='M10 10h4v7h-4zm5-8h4v15h-4zm5 0h4v21h-4zM5 2h4v10H5zM0 2h4v21H0z' />
);

export const viewBox = '0 0 25 25';
